module.exports = __webpack_public_path__ + "static/media/ads_offers.4e8dc442.svg";